



















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const couponModule = namespace("coupon");

@Component
export default class Detail extends Vue {
  active: number = 1;
  detail: any = {};

  mounted() {
    this.detail = this.$route.query;
  }
}
